<template>
  <!-- {{ this.bookingDetails }} -->
  <!-- {{ this.updatedDetails }} -->
  <div id="booking-widget">
  <!-- Alert -->
  <Alert v-if="alert">
    {{ alertmsg }}
  </Alert>
  <!-- End Alert -->
  <div class="container my-4" style="font-size:0.875rem">
    <div class="row">
      <div class="col-12 mb-4 col-md-8">
        <div class="row border pb-3">
          <div class="col-12 vue-card-unit-title m-0 mb-3 border-0">
            <h5 class="font-weight-bold mb-3">
              Manage Booking
              <span class="text-muted"><small>( Ref No. {{ this.bookingDetails.reference }} )</small></span>
            </h5>
            <a href="" class="py-3 pull-right" v-if="!this.$store.state.bookingCancelled && allowEdits" @click.prevent="toggleCancelBooking()">Cancel booking</a>
          </div>
          <div class="col-12">
            <div v-if="this.$store.state.bookingCancelled" class="alert alert-danger" role="alert">
              This booking is cancelled and therefore cannot be edited! <br/>
              Reason: {{ this.$store.getters.bookingDetails.cancellation_reason }}
            </div>
          </div>
          <div class="col-12">
            <div v-if="pastBooking" class="alert alert-danger" role="alert">
              This is a past booking and cannot be edited
            </div>
          </div>
          <div class="col-12">
            <CancelBooking :showCancel="showCancel && !this.$store.state.bookingCancelled" @alert-event="showAlert" @hide-cancel="toggleCancelBooking()" />
          </div>
          <!-- Billing Info -->
          <div class="col-12 mb-4 col-md-6">
            <BillingInfo :cancellationStatus="this.$store.state.bookingCancelled" />
          </div>
          <!-- End Billing Info -->
          <!-- Edit Dates -->
          <div class="col-12 mb-4 col-md-6">
            <BookingDates :cancellationStatus="this.$store.state.bookingCancelled" />
          </div>
          <!-- Edit Dates -->
          <!-- Room Dates -->
          <div class="col-12">
            <RoomDetails :cancellationStatus="this.$store.state.bookingCancelled" />
          </div>
          <!-- Room Dates -->
        </div>
      </div>
      <div class="col-12 col-md-4" id="terms">
        <!-- Terms -->
        <Terms />
        <!-- End Terms -->
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import moment from 'moment'
import CancelBooking from './subcomponents/CancelBooking'
import BillingInfo from './subcomponents/BillingInfo'
import BookingDates from './subcomponents/BookingDates'
import Terms from './subcomponents/Terms'
import RoomDetails from './subcomponents/RoomDetails'
import manageBooking from '../mixins/manageBooking'
export default {
  components: {
    CancelBooking,
    BillingInfo,
    Terms,
    RoomDetails,
    BookingDates
  },
  data () {
    return {
      updatedDetails: {},
      showCancel: false,
      alertmsg: 'Update Success!',
      alert: false,
      bookingCancelled: this.$store.state.bookingCancelled,
      allowEdits: true,
      pastBooking: false // when pastBooking is true, allowEdits should be false and viceversa
    }
  },
  methods: {
    dateTime (value) {
      return moment(value).format('ddd, DD MMM YYYY')
    },
    toggleCancelBooking () {
      this.showCancel = !this.showCancel
    },
    hideAllert () {
      window.setInterval(() => {
        this.alert = false
      }, 3000)
    },
    showAlert (msg) {
      this.alertmsg = msg
      this.alert = true
    }
  },
  computed: {
    bookingDetails () {
      const allData = this.$store.getters.bookingDetails
      const fullNames = allData.firstname + ' ' + allData.lastname

      const sortedData = {
        reference: allData.reference_number,
        billing_details: {
          'name': fullNames,
          'email': allData.email,
          'phone': allData.cellnumber,
          'nationality': allData.nationality
        },
        booking_dates: {
          'checkin': allData.checkin_date,
          'checkout': allData.checkout_date
        }
      }

      return sortedData
    }
  },
  mounted: function () {
    if (alert) {
      this.hideAllert()
    }
    var cancelStatus = parseInt(this.$store.getters.bookingDetails.cancellation_status)
    this.$store.state.bookingCancelled = !!cancelStatus
  },
  watch: {
    bookingCancelled () {
      console.log('booking cancelled changed')
    }
  },
  mixins: [manageBooking]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/manageBooking/ManageBooking.vue